import { DsPinStatusInterface } from '../interfaces/ds-pin-status.interface';

export const DS_PIN_STATUS: DsPinStatusInterface[] = [
  { id: 0, color: '#8DCC21', defaultLabel: 'projects.pins.statusNames.completed', label: null },
  { id: 1, color: '#DB2F23', defaultLabel: 'projects.pins.statusNames.toDo', label: null },
  { id: 2, color: '#1A5BE8', defaultLabel: 'projects.pins.statusNames.toCheck', label: null },
  { id: 3, color: '#CC3FE8', defaultLabel: 'projects.pins.statusNames.rejected', label: null },
  { id: 4, color: '#F79D1E', defaultLabel: 'projects.pins.statusNames.pending', label: null },
  { id: 5, color: '#F0D92B', defaultLabel: 'projects.pins.statusNames.completedByCompany', label: null },
  { id: 6, color: '#12E6D7', defaultLabel: 'projects.pins.statusNames.completedBySC', label: null },
];
